import { FC, ReactElement } from 'react';

import { TooltipProvider } from '@/components/ui/tooltip';

import ComposeProviders from './compose-providers';
import {
  UserContainer,
  AuthContainer,
  ClientContainer,
  ApplicationContainer,
  PagesContainer,
  ReportsContainer,
  TeamContainer,
  UpvoteContainer,
  ExportReportContainer,
  AddDatasourceContainer,
  PostsContainer,
  BillingContainer,
} from '..';
import AddonContainer from '../addon';

type InitialStateProps = {
  userState?: any;
  applicationState?: any;
  clientState?: any;
  reportsState?: any;
  insightsState?: any;
  teamState?: any;
  pagesState?: any;
  authenticationState?: any;
};

type ProviderWrapperProps = {
  children: ReactElement;
  initialState?: InitialStateProps;
};

export const ProviderWrapper: FC<ProviderWrapperProps> = ({
  children,
  initialState,
}) => {
  const providers: any = [
    {
      provider: ApplicationContainer.Provider,
      props: { initialState: initialState?.applicationState },
    },
    {
      provider: AuthContainer.Provider,
      props: { initialState: initialState?.authenticationState },
    },
    {
      provider: UserContainer.Provider,
      props: { initialState: initialState?.userState },
    },
    {
      provider: ClientContainer.Provider,
      props: { initialState: initialState?.clientState },
    },
    {
      provider: PagesContainer.Provider,
      props: { initialState: initialState?.pagesState },
    },
    {
      provider: ReportsContainer.Provider,
      props: { initialState: initialState?.reportsState },
    },
    {
      provider: UpvoteContainer.Provider,
    },
    {
      provider: TeamContainer.Provider,
    },
    { provider: ExportReportContainer.Provider },
    { provider: AddDatasourceContainer.Provider },
    { provider: PostsContainer.Provider },
    { provider: BillingContainer.Provider },
    { provider: AddonContainer.Provider },
    { provider: TooltipProvider },
  ];

  return <ComposeProviders providers={providers}>{children}</ComposeProviders>;
};
